import { render, staticRenderFns } from "./VendorOtherModal.vue?vue&type=template&id=6bc6237a&scoped=true&"
import script from "./VendorOtherModal.vue?vue&type=script&lang=js&"
export * from "./VendorOtherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6237a",
  null
  
)

export default component.exports